import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import apiInstance from "../../../apiInstance";
import defaultDocImg from "../../../../assets/images/doc.png";

const isImage = (mimetype) => mimetype && mimetype.startsWith("image/");

const AttachmentList = ({ attachments }) => {
    if (!attachments || attachments.length === 0) return null;
    return (
        <div className="mjsdev-attachments">
            {attachments.map((att) => {
                const url = `${process.env.REACT_APP_SERVER_URL}/uploads/support-tickets/${att.filename}`;
                return (
                    <div key={att.filename} className="mjsdev-attachment-preview">
                        {isImage(att.mimetype) ? (
                            <a href={url} target="_blank" rel="noreferrer">
                                <img
                                    src={url}
                                    alt={att.originalName}
                                    style={{ maxWidth: "150px", maxHeight: "100px", objectFit: "cover", borderRadius: "4px" }}
                                />
                                <span>{att.originalName}</span>
                            </a>
                        ) : (
                            <a href={url} target="_blank" rel="noreferrer">
                                <img
                                    src={defaultDocImg}
                                    alt={att.originalName}
                                />
                                <span>{att.originalName}</span>
                            </a>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

const AddReply = ({ticketDetails, updateTicket}) => {

    const [reply, setReply] = useState("");
    const [replyFiles, setReplyFiles] = useState([]);
    const currUser = useSelector((state) => state.currentUser);
    const [error, setError] = useState("");
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const selected = Array.from(e.target.files);
        if (replyFiles.length + selected.length > 5) {
            setError("Maximum 5 attachments allowed per reply.");
            return;
        }
        setReplyFiles((prev) => [...prev, ...selected]);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const removeReplyFile = (index) => {
        setReplyFiles((prev) => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {

        const messages = [
            ...(ticketDetails.messages || []),
            {
                sender: currUser.id,
                message: reply
            }
        ];

        const formData = new FormData();
        formData.append("type", "ADMIN_REPLIED");
        formData.append("messages", JSON.stringify(messages));

        replyFiles.forEach((file) => {
            formData.append("attachments", file);
        });

        apiInstance.put(`/devadmin/support-ticket/${ticketDetails._id}`, formData)
            .then((response) => {
                const returnedTicket = response.data.ticket;
                returnedTicket && updateTicket && updateTicket(returnedTicket);
                setReply("")
                setReplyFiles([])
            })
            .catch((error) => {
                console.error("Unexpected error:", error);
                if (error.response) {
                    setError(error.response.data.message || "Something went wrong, please try again later.");
                }
            });
    };

    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-inner-container">
                <h5>Message</h5>
                <div className="mjsdev-dtl-row">
                    <span>{ticketDetails.description || "No description provided."}</span>
                </div>
                <AttachmentList
                    attachments={ticketDetails.attachments}
                />
            </div>
            <div className="mjsdev-dtl-inner-container">
                <h5>Conversation</h5>
                {ticketDetails.messages?.length > 0 ? ticketDetails.messages.map((item, idx) => (
                    <div className="mjsdev-dtl-box" key={idx}>
                        <span className="mjsdev-strong">
                            {item.sender?.name || "unknown"} {", "}
                            {new Date(item.createdAt).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            })}
                        </span>
                        <span>{item.message}</span>
                        <AttachmentList
                            attachments={item.attachments}
                        />
                    </div>
                )) : (
                    <>No replies yet.</>
                )}
            </div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-dtl-row" style={{border: 'none'}}>
                    <textarea
                        className="mjs-input"
                        name="reply"
                        value={reply}
                        onChange={(e) => setReply(e.target.value)}
                        style={{width: '100%', height: '300px'}}
                    >
                        {reply}
                    </textarea>
                </div>
                <div className="mjsdev-dtl-row" style={{border: 'none'}}>
                    <div className="mjsdev-input-field" style={{ margin: 0 }}>
                        <input
                            type="file"
                            multiple
                            ref={fileInputRef}
                            accept="image/jpeg,image/png,image/gif,image/webp,.pdf,.doc,.docx"
                            onChange={handleFileChange}
                        />
                        {replyFiles.length > 0 && (
                            <div className="mjsdev-attachment-list">
                                {replyFiles.map((file, i) => (
                                    <div key={i} className="mjsdev-attachment-item">
                                        {file.type?.startsWith("image/") ? (
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt={file.name}
                                                className="mjsdev-attachment-thumb"
                                            />
                                        ) : (
                                            <img
                                                src={defaultDocImg}
                                                alt={file.name}
                                                className="mjsdev-attachment-thumb"
                                            />
                                        )}
                                        <span>{file.name}</span>
                                        <button type="button" onClick={() => removeReplyFile(i)}>&times;</button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="mjsdev-dtl-row">
                    <span></span>
                    <button
                        className="mjs-btn"
                        onClick={handleSubmit}
                    >
                        Reply
                    </button>
                </div>
            </div>
            <div className="mjs-error">{error}</div>
        </div>
    );
};

export default AddReply;
